import { useCallback, useMemo } from 'react';

import { AxiosRequestConfig } from 'axios';
import useAPI from 'hooks/use-api';
import { API } from 'redux/api';

interface AllClassAverageAttendanceResponse extends MessageResponse {
  classData: ClassAverageAttendance[];
}

export const useAllClassAttendanceData = (courseId?: string) => {
  const transformResponse = useCallback(
    (response: AllClassAverageAttendanceResponse) => response.classData,
    []
  );
  const config = useMemo<AxiosRequestConfig>(
    () => ({
      url: API.ATTENDANCE_COURSE_ALL,
      params: { courseId },
      transformResponse,
    }),
    [courseId, transformResponse]
  );
  return useAPI<ClassAverageAttendance[], MessageResponse>(config, Boolean(courseId));
};
